import styled from 'styled-components'
import { Theme } from '../../../../Theme';


const  Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 20%;
    min-width: 250px;
    max-width: 350px;
    height: 340px;
    margin: 15px;
    padding: 15px;
    box-sizing: border-box;
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.05);
    transition: all 0.3s ease-in-out;
    border: 1px solid #f0f0f0;

    &:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 30px rgba(0,0,0,0.12);
        border-color: ${Theme.SECOND_COLOR};
    }

    .Title {
      font-size: 20px;
      font-family: "Bebas Neue", sans-serif;
      color: ${Theme.FIRST_COLOR};
      margin-bottom: 10px;
      text-align: center;
      line-height: 1.1;
      height: 48px;
      display: flex;
      align-items: center;
    }

    img {
      width: 100%;
      height: 160px;
      object-fit: cover;
      object-position: center;
      display: block;
      border-radius: 12px;
      overflow: hidden;
      margin-bottom: 10px;
      background: #f9f9f9;
      transition: transform 0.3s ease;
    }

    &:hover img {
        transform: scale(1.02);
    }

    .ButtonsArea {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 8px;
        margin-top: auto;

        button {
            height: 40px;
            font-family: ${Theme.FIRST_FONT};
            font-weight: bold;
            font-size: 13px;
            width: 50%;
            cursor: pointer;
            transition: all 0.3s ease;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .LeftButton {
            background-color: transparent;
            color: ${Theme.FIRST_COLOR};
            border: 2px solid ${Theme.FIRST_COLOR};
            border-radius: 12px;

            &:hover {
                background-color: ${Theme.FIRST_COLOR};
                color: white;
            }
        }

        .RightButton {
            background-color: ${Theme.FIRST_COLOR};
            color: white;
            border-radius: 12px;
            box-shadow: 0 4px 10px rgba(38, 85, 121, 0.2);

            &:hover {
                filter: brightness(1.2);
                box-shadow: 0 6px 15px rgba(38, 85, 121, 0.3);
            }
        }
    }



    // No Mobile
    @media (max-width: 768px) {
        width: 80%;
        max-width: 100%;
    }
`;

export const Styled = {
    Content
}